<template>
  <div
    class="share"
    v-if="showShare"
    @click="aa"
  >
    <div class="
    sc">
      点击右上角分享给好友，邀请好友入团
      <img src="@/assets/share.png">
    </div>
  </div>
</template>
  
<script>
export default {
  name: "share",
  props: ["showShare"],
  data: function () {
    return {};
  },
  methods: {
    aa() {
      this.$emit("hideShare", false);
    },
  },
};
</script>
  
<style scoped lang="scss">
.share {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  .sc {
    color: #ffffff;
    font-size: 0.34rem;
    display: flex;
    margin: 2rem 0;
    img {
      width: 0.59rem;
      height: 0.63rem;
    }
  }
}
</style>